import { createSelector } from 'reselect';
import { Action } from '@ngrx/store';
import { AppState } from '../../app.state';
import { AppointmentRequest } from '../../shared/models/appointment-request.model';
import * as appointmentRequestsActions from './appointment-requests.actions';

export interface State {
  entities: AppointmentRequest[];
  selectedAppointmentRequestId: number | null;
}

const initialState: State = {
  entities: [],
  selectedAppointmentRequestId: null,
};

export function appointmentRequestsReducer(state = initialState, action: Action): State {
  switch (action.type) {
    case appointmentRequestsActions.ActionTypes.ADD_APPOINTMENT_REQUESTS:
      const appointmentRequests = action.payload;
      const newAppointmentRequests = appointmentRequests.filter((request) => !state.entities.find((entities) => entities.id === request.id));

      return {
        entities: [
          ...state.entities,
          ...newAppointmentRequests,
        ],
        selectedAppointmentRequestId: state.selectedAppointmentRequestId,
      };

    case appointmentRequestsActions.ActionTypes.SELECT_APPOINTMENT_REQUEST:
      if (state.entities.find((entity) => entity.id === action.payload)) {
        return {
          entities: state.entities,
          selectedAppointmentRequestId: action.payload,
        };
      }
      return state;

    default:
      return state;
  }
}

/* Queries */
const getEntities = (state: State) => state.entities;
const getAppointmentRequestsState = (state: AppState) => state.appointmentRequests;

export const getSelectedAppointmentRequest = createSelector(getAppointmentRequestsState, createSelector(getEntities, (state: State) => state.selectedAppointmentRequestId, (entities, selectedId) => {
  return entities.find((entity) => entity.id === +selectedId);
}));



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/home/appointment-requests/appointment-requests.reducer.ts